import { DedicatedBookingPage } from "@/components/booking/DedicatedBookingPage";

export default function BookingPresentation() {
  return <DedicatedBookingPage service="presentation" />;
}
